module.exports = __webpack_public_path__ + "img/zto_charge_logo.a5ae60e1.png";